import type { ReactElement } from "react";
import { CircularProgress, Tooltip } from "@mui/material";
import cx from "classnames";

interface StatusBadgeItemProps {
  icon: ReactElement<any>;
  value: number | string;
  className?: string;
  tooltipTitle?: string;
  isLoading?: boolean;
}

const StatusBadgeItem = ({
  icon,
  value,
  className,
  tooltipTitle,
  isLoading,
}: StatusBadgeItemProps) => (
  <Tooltip title={tooltipTitle} arrow placement="top" disableInteractive>
    <div className={cx("inline-flex items-center gap-1", className)}>
      {icon}
      {isLoading ? (
        <CircularProgress size={10} className="leading-0" />
      ) : (
        <span className="leading-3">
          {typeof value === "number"
            ? Intl.NumberFormat("en", { notation: "compact" }).format(value!)
            : value}
        </span>
      )}
    </div>
  </Tooltip>
);

export default StatusBadgeItem;
